import React from "react";
import { IonCol, IonRow } from "@ionic/react";

/** Equal space above and below each section title/icon (CSS: --rsp-entry-form-content-gap). */
export const ENTRY_FORM_SECTION_CONTENT_GAP_PX = 10;

interface EntryFormSectionHeaderProps {
    title: string;
    emoji?: string;
    /** When set, shown instead of emoji (e.g. imported PNG/SVG). */
    iconSrc?: string;
}

/**
 * Title/icon row. Bottom spacing lives here; top spacing comes from the
 * previous block’s margin/padding so title top/bottom stay equal.
 */
const EntryFormSectionHeader: React.FC<EntryFormSectionHeaderProps> = ({ title, emoji, iconSrc }) => {
    return (
        <IonRow className="entry-form-section-header">
            <IonCol className="p-0">
                <div className="entry-form-section-header__row">
                    <div className="entry-form-section-header__icon" aria-hidden="true">
                        {iconSrc ? (
                            <img src={iconSrc} alt="" className="entry-form-section-header__icon-img" />
                        ) : (
                            <span className="entry-form-section-header__icon-emoji">{emoji}</span>
                        )}
                    </div>
                    <h1 className="font-weight-bold text-info m-0">{title}</h1>
                </div>
            </IonCol>
        </IonRow>
    );
};

export default EntryFormSectionHeader;
